<template>
    <div>
        <div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <app-tabela
                idTabela="tblAlertasVigencia"
                :itens="alertas"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="botoes">
                    <div class="d-flex flex-row-reverse mb-3">
                        <btn-inserir-alerta
                            :idContrato="contrato.idContrato"
                            :dataInicioVigencia="contrato.dtInicioVigencia"
                            :dataFimVigencia = "contrato.dtFimVigencia"
                            v-if="mostrarBtnInserirAlerta"
                            @obterAlertasAtualizados="obterAlertas()"
                        ></btn-inserir-alerta>
                    </div>
                </template>
                <template slot="acoes" slot-scope="data">
                    <btn-atualizar-alerta
                        :idContrato="contrato.idContrato"
                        :dataInicioVigencia="contrato.dtInicioVigencia"
                        :dataFimVigencia = "contrato.dtFimVigencia"
                        :alerta="data"
                        v-if="mostratBtnAtualizarAlerta"
                        @obterAlertasAtualizados="obterAlertas()"
                    ></btn-atualizar-alerta>
                    <btn-excluir-alerta
                        :idContrato="contrato.idContrato"
                        :alerta="data"
                        v-if="mostrarBtnExcluirAlerta"
                        @obterAlertasAtualizados="obterAlertas()"
                    ></btn-excluir-alerta>
                </template>
                <template slot="dataAlerta" slot-scope="data">
                    {{
                        data.dataAlerta
                            ? $moment(data.dataAlerta).format('DD/MM/YYYY')
                            : ''
                    }}
                </template>
                <template slot="status" slot-scope="data">
                        <app-status
                            :status="data.status.toUpperCase()"
                        ></app-status>
                    </template>

            </app-tabela>
        </div>
    </div>
</template>

<script>
import AlertasServicos from './AlertasServicos'
import BtnAtualizarAlerta from './BtnAtualizarAlerta.vue'
import BtnExcluirAlerta from './BtnExcluirAlerta.vue'
import BtnInserirAlerta from './BtnInserirAlerta'

export default {
    components: {
        BtnInserirAlerta,
        BtnExcluirAlerta,
        BtnAtualizarAlerta
    },
    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            erros: [],
            campos: [
                {
                    key: 'dataAlerta',
                    label: 'Data Alerta',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'motivo',
                    label: 'Motivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10,
            alertas: [],
            status: 0
        }
    },
    methods: {
        obterAlertas() {
            this.$store.dispatch('addRequest')
            AlertasServicos.obterAlertasPorContrato(
                this.$route.params.contratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.alertas = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter os alertas',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        
        obterAlertaPorId() {
            this.$store.dispatch('addRequest')
            AlertasServicos.obterAlertaPorId(
                this.idContrato,
                this.alerta.alertaId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.alerta = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter alerta',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })  
        },

        atualizarAlertas(alerta) {
            this.alertas.push(alerta)
        }
    },
    mounted() {
        this.obterAlertas()
    },
    computed: {
        mostrarBtnInserirAlerta() {
            return this.$temAcessoView()
        },
        mostrarBtnExcluirAlerta() {
            return this.$temAcessoView()
        },
        mostratBtnAtualizarAlerta() {
            return this.$temAcessoView()
        }
    }
}
</script>